<template>
  <div class="filter-name"
       :class="filterNameStyles">
    <div class="filter-name-label">
      {{ $t("customContentFilter.filterName") }}:
    </div>

    <div class="filter-name-input-container">
      <input v-model="name"
            v-validate="'required|max:50'"
            name="filter-name"
            class="filter-name-input"
            @input="$emit('changeName', name)" />

      <span class="filter-name-input-error">
        {{ errors.first('filter-name') }}
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      filterName: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        name: ''
      }
    },

    created() {
      this.name = this.filterName
    },

    computed: {
      filterNameStyles() {
        return {
          'filter-name-mobile': this.$mq === 'mobile'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .filter-name {
    width: 100%;

    display: flex;
    justify-content: space-between;
    align-items: center;

    margin: 0 auto 20px;

    .filter-name-input-container {
      width: 80%;
      height: 30px;

      .filter-name-input {
        width: 100%;
        height: 30px;

        border: none;
        border-bottom: 2px solid map-get($colors, primary);

        font-size: 24px;
        font-weight: bold;
        text-align: center;
        color: map-get($colors, primary);
      }

      .filter-name-input-error {
        font-size: 12px;
        color: #ff0000;
      }
    }

    &-label {
      width: 25%;
      font-size: 20px;
      color: map-get($colors, primary)
    }
  }

  .filter-name-mobile {
    margin: 0 auto 5px;
  }
</style>